import { createAction, props } from '@ngrx/store';
import { Area } from '@us/web/shared/data-access';

export const init = createAction('[Areas Page] Init');

export const loadAreasSuccess = createAction('[Areas/API] Load Areas Success', props<{ areas: Area[] }>());

export const loadAreasFailure = createAction('[Areas/API] Load Areas Failure', props<{ error: any }>());
